module.exports = __webpack_public_path__ + "static/media/feature-4.0d8c2665.png";